/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from 'react';
import { useOutletContext } from "react-router-dom";
// Material UI
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
// Status Stepper
import StatusStepper from '../StatusStepper';
import CourseStatusSteps from '../../../../main/courses/instance/CourseStatusSteps';
import LessonStatusSteps from '../../../../main/lessons/instance/LessonStatusSteps';
import SectionStatusSteps from '../../../../main/sections/instance/SectionStatusSteps';

export default function StatusProd(props) {
  const { resource, instance } = useOutletContext();

  // use a switch statement to determine the steps from the resource
  const handleSteps = (resource) => {
    switch (resource) {
      case 'courses':
        return CourseStatusSteps;
      case 'lessons':
        return LessonStatusSteps;
      case 'sections':
        return SectionStatusSteps
      default:
        return [];
    }
  }

  return (
    <div className="relative flex flex-col flex-auto mt-64 px-24 sm:px-48">
      <Typography className="mt-12 text-2xl font-bold truncate">
        Production Status
      </Typography>
      <Divider className="mt-16 mb-24" />
      <StatusStepper steps={handleSteps(resource)} activeStep={instance.status.production} />
    </div>
  );
}